module.exports = __webpack_public_path__ + "img/teambox-freisteller.ec48b7b1.png";